import { render, staticRenderFns } from "./BlackBoard.vue?vue&type=template&id=7b5b535b&scoped=true&"
import script from "./BlackBoard.vue?vue&type=script&lang=js&"
export * from "./BlackBoard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.10.1_sqwtrzbl6s4ypz4dmnoirtpj7i/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b5b535b",
  null
  
)

export default component.exports